import Client from '../Client'

const Register = async (values) => {
    try {
        const response = await Client.post('/v1/auth/register', values)
        return {
            success: true,
            token: response.data.token,
            user: response.data.user,
        }
    } catch (e) {
        if (e.response) {
            return { error: e.response.data.message }
        } else {
            return { error: 'Unknown error happened' }
        }
    }
}

export default Register
